// Modules
import { ReactElement } from "react"
import { useFormContext, UseFormRegisterReturn } from "react-hook-form"

// Components
import { InputContainer } from "~styled/input"
import { ModalTextarea } from "~styled/textarea"

interface TextareaProps {
  name?: string
  label?: string
  height?: number
  disabled?: boolean
  infoCopy?: string
  register?: UseFormRegisterReturn<string>
  className?: string
  maxLength?: number
  placeholder?: string
  autoComplete?: "on" | "none"
  errorMessage?: string
}

const Textarea = (props: TextareaProps) => {
  const {
    name,
    label,
    height = 80,
    disabled,
    infoCopy,
    register,
    className,
    maxLength,
    placeholder,
    autoComplete = "none",
    errorMessage,
  } = props

  // Using the form context
  const { watch } = useFormContext()
  const inputValue = name ? watch(name) : ""

  // Method to display "error message" or "info copy"
  const showErrorOrInfo = (): ReactElement => {
    if (errorMessage) {
      return <span className="error-message">{errorMessage}</span>
    }
    return <span className="info-copy">{infoCopy}</span>
  }

  return (
    <InputContainer className={className}>
      <span className="label">{label}</span>

      <ModalTextarea
        {...register}
        name={name || register?.name}
        style={{ height }}
        disabled={disabled}
        className={errorMessage && "error"}
        placeholder={!label ? placeholder : ""}
        autoComplete={autoComplete}
        maxLength={maxLength}
      />

      <div className="input-bottom">
        {/* Show error message or info */}
        {showErrorOrInfo()}

        {/* Show textarea limit count */}
        {maxLength && inputValue?.length >= 0 && (
          <span className="input-limit">
            {inputValue.length}/{maxLength}
          </span>
        )}
      </div>
    </InputContainer>
  )
}

export default Textarea
